import {
  BABY_DISCHARGE_LABEL,
  isBabyDischargeSummary,
} from "features/results/utils/neonatalDischarge";

export const DISCHARGE_SUMMARIES_LABEL = "Discharge Summaries";
export const DISCHARGE_SUMMARIES_MENU_VALUE = "DISCHARGE_SUMMARIES";

/*
 * Whose discharge this row describes (KIN-2028).
 *
 * A neonatal summary is filed on the mother (KIN-1926), so her Documents screen lists a document
 * about her baby among her own. KIN-1949 exists to stop that reading as hers, and a new section
 * rendering these rows without the distinction would reintroduce exactly that bug — so the label
 * comes from the same `resolvedMotherPatientId` contract rather than from the message afresh.
 */
export const describeDischargeSubject = (summary) =>
  isBabyDischargeSummary(summary) ? BABY_DISCHARGE_LABEL : "Patient's own";
